module.exports = __webpack_public_path__ + "static/fonts/Campton-Bold.51f14df.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Campton-Bold.woff2
// module id = zHxG
// module chunks = 1